import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect, useState } from 'react';

import Header from '@components/common/Header/Header';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';

import useTranslation from '@hooks/useTranslation';

import LocationBlock from './components/LocationBlock/LocationBlock';
import LocationsLog from './components/LocationsLog/LocationsLog';
import style from './style.module.scss';

const ManageLocations = () => {
  const { trackPageView } = useMatomo();
  const { t } = useTranslation();

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <>
      <Header
        title={t('Manage Locations')}
        showLogo={true}
        showFacilitySelect={true}
        extraInfo={
          <FilterSearch
            value={searchValue}
            onChange={setSearchValue}
            variant={'header-search'}
            placeholder={t('Search Locations...')}
          />
        }
      />
      <div className={style.manageLocations}>
        <LocationBlock searchValue={searchValue} />
        <LocationsLog searchValue={searchValue} />
      </div>
    </>
  );
};

export default ManageLocations;
